













import BookmarkMixin from '@/components/Cartable/EnterpriseForm/BookmarkComponents/BookmarkMixin';
import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
@Component
export default  class  CurrencyBookmarkMobile extends Mixins(BookmarkMixin){
    amount = '';
    created(){
        this.value = 0;
    }
    @Watch('amount')
    onAmountChanged(newVal: string, oldVal: string){
         if(!newVal)return;
        const array = newVal.split('');
        if(array.length == 0)return;
        if(isNaN(parseInt(array[array.length -1]))){
             this.amount = (this.amount as string).substring(0,this.amount.length -1);
        }
        this.amount = this.amount.replace(',','');
        this.amount = this.formatMoney(this.amount);
    }
    formatMoney(amount: string) {
        amount =  amount.replace(',','');
        const j = (amount.length > 3) ? amount.length % 3 : 0;
        // const result =   (j ? amount.substr(0, j) + "," : '') + amount.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",");
        const result =   (j ? amount.substr(0, j) + "," : '') + amount.substr(j).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return result;
    }
    focusOut(){
        const result=this.amount.replace(/,/g,'')
        this.value = parseInt(result);
        this.$emit("value-changed",this.englishName);
    }
    onValueChanged(){
        this.amount = this.formatMoney((this.value as number).toString());
    }
}
